import { Component, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { UntypedFormGroup } from '@angular/forms';
import { Config } from '@shared/config';
import { Response } from '@shared/models/response.model';
import { SuccessRes } from '@shared/interfaces/success-res.interface';
import { FooterService } from '@shared/components/footer/footer.service';
import { AppInjector } from '@shared/services/app-injector.service';

@Component({
  selector: 'app-base-form',
  template: '',
})
export class BaseFormComponent extends BaseComponent {
  recaptchaSiteKey: string = Config.RECAPTCHA_SITE_KEY;
  loading: boolean = false;
  form: UntypedFormGroup = new UntypedFormGroup({});
  @Output() closeModalEmitter: EventEmitter<any> = new EventEmitter();
  recaptchaToken: string = null;
  captchaValid: boolean = false;
  contact: string = '';
  footerService: FooterService;

  constructor() {
    super();
    const injector = AppInjector.getInjector();
    this.footerService = injector.get(FooterService);
  }

  addRecaptchaScript(name: string) {
    this.contact = name;
  }

  submitContactForm(ukrainianEvent, user_to?) {
    this.loading = true;
    if (this.recaptchaToken) {
      this.send(this.recaptchaToken, ukrainianEvent, user_to);
    } else {
      this.loading = false;
      this.toast.error(
        this.translate.instant('HOMEPAGE.accept_captcha'),
        this.translate.instant('HOMEPAGE.contact_form_error')
      );
    }
  }

  send(token, event?: boolean, user_to?: number) {
    if (event) {
      const pack = {
        user_to,
        email: this.form.value.email,
        title: this.form.value.title,
        phone_number: this.form.value.phoneNumber,
        message: this.form.value.message,
        contact_consent: this.form.value.contactConsent,
        captcha: token,
      };
      const subSend = this.footerService
        .ukrainianSendContactForm(pack)
        .subscribe((el: Response<SuccessRes>) => {
          this.loading = false;
          this.closeModal();
          switch (this.contact) {
            case 'email-send':
              this.toast.success(
                this.translate.instant('HOMEPAGE.message_send'),
                this.translate.instant('HOMEPAGE.contact_form_success')
              );
              break;
            case 'press-email-send':
              this.toast.success(
                this.translate.instant('HOMEPAGE.message_send'),
                this.translate.instant('HOMEPAGE.press_form_success')
              );
              break;
          }
        }, this.onSendError.bind(this));
      this.someSubscriptions.add(subSend);
    } else {
      const pack = {
        email: this.form.value.email,
        title: this.form.value.title,
        message: this.form.value.message,
        captcha: token,
      };
      const subSend = this.footerService
        .sendContactForm(pack, this.contact)
        .subscribe((el: Response<SuccessRes>) => {
          this.loading = false;
          this.closeModal();
          switch (this.contact) {
            case 'email-send':
              this.toast.success(
                this.translate.instant('HOMEPAGE.message_send'),
                this.translate.instant('HOMEPAGE.contact_form_success')
              );
              break;
            case 'press-email-send':
              this.toast.success(
                this.translate.instant('HOMEPAGE.message_send'),
                this.translate.instant('HOMEPAGE.press_form_success')
              );
              break;
          }
        }, this.onSendError.bind(this));
      this.someSubscriptions.add(subSend);
    }
  }

  closeModal() {
    this.closeModalEmitter.emit();
    this.form.reset();
    if (this.storage.user) {
      this.form.get('email').setValue(this.storage.user.email);
    }
    this.loading = false;
    this.recaptchaToken = null;
    this.captchaValid = false;
  }

  onSendError() {
    this.loading = false;
    this.toast.error(
      this.translate.instant('HOMEPAGE.cant_send'),
      this.translate.instant('HOMEPAGE.contact_form_error')
    );
  }

  resolvedRecaptcha(captchaResponse: string) {
    this.captchaValid = !!captchaResponse;
    this.recaptchaToken = captchaResponse;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  handleSuccessRecaptcha(captchaResponse: string) {
    this.captchaValid = !!captchaResponse;
    this.recaptchaToken = captchaResponse;
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  errorRecaptcha($error) {
    console.log($error, 'Error captcha');
  }
}
